import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { Button } from "rsuite";
import { EventCard } from "../components/eventcard";
import ConfigContext from "../utils/Config";
import AuthContext from "../utils/Auth";
import { getAllEvents } from "../utils/Api/eventsApi";
import { useTranslation } from "react-i18next";
import EventComponent from "../components/Events/EventComponent";
import { InfiniteScrollComponent } from "../components/InfiniteScrollComponent";
import moment from "moment";

type evento = {
  id: number;
  eventname: string;
  eventdate: string;
  id_club: number;
  eventenddate: string;
  eventendtime: string;
  eventinitdate: string;
  eventinitime: string;
  urlimagen: string;
  streams?: {
    count: number;
  };
  lives?: [];
};

export function Eventos() {
  const [t] = useTranslation("global");
  const { currentConfig, GetConfig } = useContext(ConfigContext);

  const [event, setEvent] = useState<evento[]>([]);
  const [page, setPage] = useState<number>(0);
  const { currentUser } = useContext(AuthContext);
  const [crearEvento, setCrearEvento] = useState(false);
  const [ClubList, setClubList] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [visibleCount, setVisibleCount] = useState<number>(20);

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 20);
    setPage((prev) => prev + 1);
  };

  const cargarClubs = () =>
    setClubList(
      currentConfig?.clubs
        ?.filter(({ id_admin }) => id_admin === currentUser?.id_player)
        .map(({ displayname, id }) => ({ label: displayname, value: id })) || []
    );

  const getEvents = async () => {
    setLoading(true);
    try {
      const response = await getAllEvents();
      const eventsSorted = response.data.sort(
        (a, b) =>
          new Date(b.eventdate).getTime() - new Date(a.eventdate).getTime()
      );
      setEvent(eventsSorted);
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEvents();
    GetConfig();
    cargarClubs();
  }, []);

  return loading ? (
    <div className="cssload-loader">
      <div className="cssload-inner cssload-one"></div>
      <div className="cssload-inner cssload-two"></div>
      <div className="cssload-inner cssload-three"></div>
    </div>
  ) : (
    <>
      <div className="flex items-center justify-center my-4">
        <h1 className="text-xl font-semibold text-center text-gray-800">
          {t("Events.title")}
        </h1>
      </div>

      {currentUser ? (
        currentUser.id_membership === 0 || currentUser.id_membership === 3 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              className="text-base font-medium text-center text-white bg-black btn hover:text-black hover:bg-red-500 hover:ring-black hover:ring-2 "
              onClick={() => {
                cargarClubs();
                setCrearEvento(true);
              }}
            >
              <FontAwesomeIcon className="eventicon" icon={faAdd} />
              {t("Events.createEvent")}
            </Button>
          </div>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}

      <div className="flex flex-wrap justify-center">
        {event && event.length > 0 ? (
          event.slice(0, visibleCount).map((ev: evento, key) => {
            const eventDate =` Inicio ${ moment(ev.eventdate).utc().format("DD/MM/YYYY")}`;            
            return (
              <EventCard
                key={Math.floor(Math.random() * 100) + 1 * key}
                id={ev.id.toString()}
                club={ev.id_club.toString()}
                dateevent={eventDate}
                streams={ev.streams.count}
                content={ev.eventname}
                urlimagen={ev.urlimagen}
              />
            );
          })
        ) : (
          <div className="flex items-center justify-center my-4">
            <h4 className="text-xl font-semibold text-center text-gray-800">
              {t("Events.notEvent")}
            </h4>
          </div>
        )}
        <InfiniteScrollComponent
          loading={loading}
          hasMore={visibleCount < event.length}
          onLoadMore={handleShowMore}
        />
      </div>
      <div className="flex items-center justify-center my-4">
        {visibleCount >= event.length && (
          <h4 className="text-xl font-semibold text-center text-gray-800">
            Wow, llegaste al final.Eso es todo lo que tenemos hasta el momento.
          </h4>
        )}
      </div>
      {crearEvento && (
        <EventComponent
          isOpen={crearEvento}
          SetOpen={setCrearEvento}
          title={t("Events.createEvent")}
          ClubList={ClubList}
        />
      )}
    </>
  );
}
